import { Box } from '@mantine/core'

// Update RoleTag type to only allow valid roles
export interface RoleTagProps {
  role: 'SWI Admin' | 'Admin' | 'SME' | 'User'
}

export function RoleTag({ role }: RoleTagProps) {
  const colorMap = {
    Admin: '#37B24D',
    SME: '#7950F2',
    User: '#4394E5',
    'SWI Admin': '#FFA500',
  }

  return (
    <Box
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 12px',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: 500,
        border: `1px solid ${colorMap[role]}40`,
        backgroundColor: `${colorMap[role]}15`,
        color: colorMap[role],
        minWidth: '90px',
        height: '24px',
      }}>
      {role}
    </Box>
  )
}
